// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__mydqL","footer-content":"Footer_footer-content__QTVnJ","created":"Footer_created__0-3fK","links":"Footer_links__DSQZV","link":"Footer_link__-ZoQH"};